import { Box, Button, Paper, Typography } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import socials from "../../../../../data/socials.json";
import MobileContactForm from "./MobileContactForm";
import ContactHelmet from "../../../../../Helmets/ContactHelmet";

export default function MobileContactPage() {
  function handleCall() {
    window.location.href = `tel:${socials.tel}`;
  }

  return (
    <Box
      sx={{
        mt: 6,
        mb: 6,
      }}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <ContactHelmet />
      <Paper sx={{ p: 2 }}>
        <Typography>Μπορείτε να μας καλέσετε</Typography>
        <Button
          sx={{ m: 1 }}
          variant="contained"
          startIcon={<PhoneIcon />}
          onClick={handleCall}
        >
          {socials.tel}
        </Button>
        <Button
          sx={{ m: 1 }}
          variant="contained"
          startIcon={<PhoneIcon />}
          onClick={handleCall}
        >
          {socials.tel1}
        </Button>
      </Paper>
      <MobileContactForm />
    </Box>
  );
}
